export const ngo_list = `/v2/guest/filter-ngos`;
export const NGO_BY_ID = (id) => `/v2/guest/filter-ngos/${id}`;
